import { alpha, darken, Grid, TableCell, TableHead } from "@mui/material";
import { styled } from "@mui/material/styles";
import { COLORS } from "src/_globalStore/redux/reducers/Theme/themeConstants";

export const HeaderRow = styled(TableHead)(({ theme }) => ({
  // display: "flex",
  // flexWrap: "nowrap",

  "& .MuiTableCell-root": {
    borderRight: `1px solid ${darken(COLORS.black_gradients.greyLight, 0.2)}`,
    height: "75px",

    "&:first-of-type": {
      borderTopLeftRadius: "15px",
    },

    "&:last-of-type": {
      borderRight: "0px",
      borderTopRightRadius: "15px",
    },
  },
}));

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "width",
})<{ flex?: number; width?: number }>(
  ({ theme }) => ({
    // display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: " 0 5px",
    backgroundColor: alpha(theme.palette.primary.main, 0.14),
    zIndex: 3,
  }),
  ({ flex, theme }) => ({
    ...(!!flex && {
      flex,
    }),
  }),
  ({ width, theme }) => ({
    ...((!!width || width === 0) && {
      width: `${width}px`,
      minWidth: `${width}px`,
      maxWidth: `${width}px`,
    }),
  })
);

export const HeaderCellContent = styled(Grid)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
}));
